import { useListAdhocMessagesQuery } from '@/store/api';
import { getConfig } from '@/config';
/**
 * Platform-services hook for fetching adhoc messages (system notifications).
 *
 * Polls the endpoint every 60 seconds to pick up new notifications.
 *
 * @see src/store/api/cc/adhocMessageApi.ts
 */
export const useGetAdhocMessages = () => {
    const config = getConfig();
    const { data, isLoading, isFetching, isError, error, } = useListAdhocMessagesQuery({ clientId: config.customer }, { pollingInterval: 60000 });
    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
    };
};
